import { useState } from "react";
import { CreditCard } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { CreditSimulator } from "@/components/CreditSimulator";
import { FINANCING_MIN_AMOUNT } from "@/lib/banks";

export const FinancingBanner = ({ price, articleRef = "", country = "CI" }) => {
  const [open, setOpen] = useState(false);
  if (!price || price < FINANCING_MIN_AMOUNT) return null;

  return (
    <>
      <div
        className="mt-4 rounded-2xl p-4 text-white bg-gradient-to-r from-indigo-600 to-violet-500 shadow-lg"
        data-testid="financing-banner"
      >
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-white/20 grid place-items-center shrink-0">
            <CreditCard size={20} />
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-bold text-sm">💳 Financez cet achat</div>
            <p className="text-xs text-white/85 mt-0.5">
              Payez en plusieurs fois avec nos banques partenaires UEMOA. Taux dès 8,5%.
            </p>
          </div>
        </div>
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="mt-3 w-full bg-white text-indigo-700 font-bold text-sm py-2.5 rounded-full hover:bg-indigo-50 transition-colors"
          data-testid="financing-open-btn"
        >
          Simuler mon crédit
        </button>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md max-h-[90vh] overflow-y-auto" data-testid="financing-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <CreditCard size={18} className="text-indigo-600" /> Simulateur de crédit
            </DialogTitle>
          </DialogHeader>
          <CreditSimulator articleRef={articleRef} defaultAmount={price} defaultCountry={country} />
        </DialogContent>
      </Dialog>
    </>
  );
};
